import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "breadcrumb--wrapper" }
const _hoisted_2 = { class: "breadcrumb" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "breadcrumb-active" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (!$props.backButton)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.props.crumbs, (crumb, index) => {
            return (_openBlock(), _createElementBlock("li", { key: index }, [
              (!$setup.isLast(index))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "breadcrumb-item-link",
                    onClick: ($event: any) => ($setup.selected(crumb, index))
                  }, _toDisplayString($props.crumbLabel ? crumb.label : "Back"), 9, _hoisted_3))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        : (_openBlock(), _createElementBlock("li", {
            key: 1,
            onClick: $setup.onBack
          }, [...(_cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "breadcrumb-item-link" }, "Back", -1)
          ]))]))
    ]),
    _createElementVNode("button", _hoisted_4, _toDisplayString($setup.lastChild.label), 1)
  ]))
}